import { render, staticRenderFns } from "./UpdateProjectModuleVisea.vue?vue&type=template&id=a0a79204&"
import script from "./UpdateProjectModuleVisea.vue?vue&type=script&lang=js&"
export * from "./UpdateProjectModuleVisea.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProjectModuleVisea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports